export enum SchoolsScopes {
  CAN_VIEW_OWN = 'can_view_own',
  CAN_VIEW_BY_DOMAIN = 'can_view_by_domain',
  CAN_UPDATE_OWN = 'can_update_own',
  CAN_UPDATE_BY_DOMAIN = 'can_update_by_domain',
  CAN_CREATE = 'can_create',
  CAN_DELETE = 'can_delete',
}
